import styled from "styled-components";

import materialUI from "../../material-UI";

export const CheckBox = styled(materialUI.Checkbox)``;
